import { Trans } from "react-i18next";
import React from "react";

const featureData = {
	featureList: [
		{
			id: 1,
			imgUrl: require('../assets/img/features/ico_01.png'),
			heading: <Trans i18nKey="feature.realtime.title" />,
			info: <Trans i18nKey="feature.realtime.desc" />
		},
		{
			id: 2,
			imgUrl: require('../assets/img/features/ico_04.png'),
			heading: <Trans i18nKey="feature.photo.title" />,
			info: <Trans i18nKey="feature.photo.desc" />
		},
		{
			id: 3,
			imgUrl: require('../assets/img/features/ico_05.png'),
			heading: <Trans i18nKey="feature.ble.title" />,
			info: <Trans i18nKey="feature.ble.desc" />,
		},
		{
			id: 4,
			imgUrl: require('../assets/img/features/ico_03.png'),
			heading: <Trans i18nKey="feature.hot.title" />,
			info: <Trans i18nKey="feature.hot.desc" />
		}
	]
};

export default featureData;
